export class ApplyWawiMappingModel {
  constructor(
    public exportMode?: boolean,
    public fieldToMappingId?: { [field: string]: string; }
  ) { }
}
